import GroomingSelfies from "../../../views/GroomingSelfies";
import MenuNames from "../../../constants/Menu/MenuNames.json";

const GroomingSelfiesRoutes = [
  {
    menuName: MenuNames.DRIVER_SELFIES,
    path: "/selfies",
    component: GroomingSelfies,
    exact: true,
  },
];

export default GroomingSelfiesRoutes;
